module.exports = __webpack_public_path__ + "static/media/settings.8ce4500a.svg";